<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('orderDate') }" class="colStyle px-1">
      {{ items.orderDate }}
    </div>
    <div v-bind:style="{ width: getWidth('supplierId') }" class="colStyle px-1">
      {{ getSupplierName(items) }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle px-1">
      {{ getUserName(items.user) }}
    </div>
    <div v-bind:style="{ width: getWidth('amount') }" class="colStyle px-1">
      {{ maskText(getAmount(items), authority.isAdmin || authority.isUser) }}
    </div>

    <!-- ステータス -->
    <div class="yCenter font-weight-bold">
      <span class="yCenter operationAreaStyle mr-1">
        <span class="primary--text statusNameStyle mr-1">
          {{
            isAfterWithdraw
              ? $t('payment.payment_already-payment-exe')
              : $t('payment.payment_not-payment-exe')
          }}
        </span>
        <NormalButton
          :text="$t('storage.storage_payment-operation')"
          btnClass="pa-2"
          height="32px"
          :disabled="buttonStatus.isComplete"
          v-if="buttonStatus.isValid && authority.isAdmin"
          @click="payment.dialog.dialog = true"
        />
      </span>
      <WithdrawDialog
        v-model="payment.dialog"
        :text="$t('storage.storage_payment-operation')"
        width="80%"
        :recItems="items"
        @complete="paymentcomplete()"
      />

      <span class="yCenter operationAreaStyle mr-1">
        <span class="primary--text statusNameStyle mr-1">
          {{
            isAfterLoading
              ? $t('loading.loading_already-loading')
              : $t('loading.loading_not-loading')
          }}
        </span>
        <NormalButton
          :text="$t('loading.loading_loading-operation')"
          btnClass="pa-2"
          height="32px"
          :disabled="buttonStatus.isComplete"
          v-if="buttonStatus.isValid"
          @click="onClickCommon('loading')"
        />
      </span>

      <span class="yCenter operationAreaStyle mr-1">
        <span class="primary--text statusNameStyle mr-1">
          {{ getCompleteStatus(items) }}
        </span>
        <template v-if="buttonStatus.isValid">
          <NormalButton
            v-if="this.buttonStatus.isComplete && authority.isAdmin"
            :text="$t('order.order_complete-cancellation')"
            btnClass="pa-2"
            height="32px"
            @click="onClickComplete()"
          />
          <NormalButton
            v-else-if="!this.buttonStatus.isComplete && authority.isAdmin"
            :text="$t('order.order_ordering-operation')"
            btnClass="pa-2"
            height="32px"
            @click="onClickComplete()"
          />
        </template>
      </span>
      <CompleteDialog
        v-model="complete.dialog"
        @complete="completeMethod"
        :title="$t('order.order_ordering-operation')"
        :noName="$t('order.order_order')"
        :noValue="items.transaction.controlNumber"
        :dateName="$t('order.order_order-completion')"
        :buttonName="$t('order.order_order-completion')"
      />

      <NormalButton
        :text="$t('storage.storage_status-history')"
        class="mr-2"
        btnClass="pa-2"
        height="32px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="statusHistory.dialog.dialog = true"
      />
      <StatusHistoryDialog
        v-model="statusHistory.dialog"
        :pageType="pageType"
        :tables="statusHistory.tables"
        itemKey=""
      />

      <NormalButton
        :text="$t('order.order_order-detail')"
        class="mr-2"
        btnClass="pa-2"
        height="32px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="onClickCommon('orderDetail')"
      />

      <NormalButton
        v-if="authority.isAdmin || authority.isUser"
        :text="$t('common.common_document')"
        btnClass="pa-2"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="onClickLedgerSheetPurchaseOrder"
      />
    </div>
  </div>
</template>
<script>
import { orderUtil, productMovesUtil } from '@/util'
import pageCommonMethods from '../script'

import NormalButton from '@/components/items/Buttons/NormalButton'

import { mapGetters, mapActions } from 'vuex'

import { commonUtil } from '@/util'

import {
  CompleteDialog,
  StatusHistoryDialog,
  WithdrawDialog
} from '@/components/layouts/Dialogs'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    NormalButton,
    CompleteDialog,
    StatusHistoryDialog,
    WithdrawDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    pageType: 'Order',
    recKeyIdName: 'orderId',

    rowDialogMethodCommonName: 'rowDialogMethodCommon',

    buttonStatus: {
      isComplete: false,
      isValid: true
    },

    statusHistory: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    complete: {
      dialog: {
        dialog: false,
        data: {
          id: '',
          date: ''
        }
      }
    },
    loading: {
      pageInfoData: {}
    },
    payment: {
      dialog: {
        dialog: false
      }
    },
    orderDetail: {
      dialog: {
        dialog: false
      },
      pageInfoData: {}
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Order', ['registerOrderComplete', 'cancelOrderComplete']),
    ...mapActions('Common', ['setIsLoading']),

    ini() {
      this.buttonStatus = {
        isComplete:
          this.items.status == 1 && this.items.compDate ? true : false,
        isValid: this.items.status !== 99
      }

      this.complete.dialog.data.id = this.items[this.recKeyIdName]

      const statusHistoryTables =
        pageCommonMethods.methods.createStatusHistoryItems(
          orderUtil.getStatusHistoryTypeList(),
          this.items.orderStatusHistories,
          ''
        )
      // 表示順とステータス.typeID順が異なる
      this.statusHistory.tables = ['出金', '入庫', '完成'].map((type) => {
        return statusHistoryTables.find((ele) => ele.type === type)
      })

      // this.loading.pageInfoData = {
      //   line1: {
      //     // storageName: this.items.storage.name,
      //     // loadingDate: this.items.loadingDate,
      //     storageName: {},
      //     loadingDate: commonUtil.getToday(),
      //     remarks: {
      //       data: '',
      //       title: '',
      //       text: ''
      //     }
      //   }
      // }
    },
    getCompleteStatus(rec) {
      if (!this.buttonStatus.isValid) return this.$t('order.order_invalid')
      return this.buttonStatus.isComplete
        ? this.$t('sale.sale_completion')
        : this.$t('order.order_unfinished')
    },

    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getSupplierName(order) {
      return orderUtil.getSupplierDisplayName(order)
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getAmount(rec) {
      const ret = productMovesUtil.getTotalAmountAndUnit(
        rec.productMoves,
        rec.currencyId
      )
      const addAmount = BigNumber(
        Number(rec.consumptionTax10) +
          Number(rec.consumptionTax8) +
          Number(rec.comission)
      )
        .minus(Number(rec.discount))
        .toNumber()
      const amount = commonUtil.formatPrice(
        BigNumber(ret.amount).plus(addAmount).toNumber()
      )

      return commonUtil.formatPrice(amount).toLocaleString() + ret.unit
    },

    paymentcomplete() {
      this.payment.dialog.dialog = false
      this.pageReload()
    },

    async completeMethod() {
      if (!this.isAfterWithdraw || !this.isAfterLoading) {
        let confirmMessage = ''
        if (!this.isAfterWithdraw && this.isAfterLoading) {
          confirmMessage = this.$t('payment.payment_not-payment-alert')
        } else if (this.isAfterWithdraw && !this.isAfterLoading) {
          confirmMessage = this.$t('loading.loading_not-loding-alert')
        } else {
          confirmMessage = this.$t('loading.loading_not-loding-payment-alert')
        }
        confirmMessage += `\n${this.$t('order.order_order-comp-confirm')}`
        if (!confirm(confirmMessage)) return
      }
      this.setIsLoading(true)

      const isSucceed = await this.registerOrderComplete(
        this.complete.dialog.data
      )
      if (isSucceed) {
        this.complete.dialog.dialog = false
        this.pageReload()
      }
      this.setIsLoading(false)
    },

    onClickCommon(type) {
      this.$emit(this.rowDialogMethodCommonName, type, [
        this.items,
        this[type].pageInfoData
      ])
    },
    async onClickComplete() {
      if (!this.buttonStatus.isComplete) {
        this.complete.dialog.dialog = true
        return
      }
      if (!confirm(this.$t('order.order_restore-order-question'))) return
      const isSucceed = await this.cancelOrderComplete(
        this.complete.dialog.data
      )
      if (isSucceed) {
        alert(this.$t('common.common_saved-alert'))
        this.pageReload()
      }
    },
    pageReload() {
      this.$emit(this.rowDialogMethodCommonName, 'reload')
    },
    onClickLedgerSheetPurchaseOrder() {
      this.$emit('onClickLedgerSheet', 'purchaseOrder', this.items)
    }
  },
  watch: {
    items: {
      deep: true,
      handler(newVal, oldVal) {
        this.ini()
      }
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    isAfterWithdraw() {
      return this.items.paymentDate
    },
    isAfterLoading() {
      return this.items.loadingDate
    }
  }
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.operationAreaStyle {
  width: 120px;
}
.statusNameStyle {
  width: 36px;
}
</style>
